import React, { Fragment, StrictMode, useEffect } from "react";
import { hot } from "react-hot-loader/root";
import { Meta } from "@sicredi/react";
import { Routes } from "#/routes";

import TagManager from "react-gtm-module";

export const App: React.FC = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-KZ3LWR9",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <Fragment>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <Routes />
        </StrictMode>
      </main>
    </Fragment>
  );
};

export default hot(App);
